import React from 'react'
import Link from 'gatsby-link'
import Logo from '../Logo'
import './index.scss'

const Popupmenu = ({ active }) => (
  <div className={`popup-menu ${active ? 'active' : ''}`}>
    <div className="popup-menu-container">
      <Logo width="100" color="#fff" />
      <ul className="nav flex-column">
        <li className="nav-item">
          <a className="nav-link active" href="#">Active</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#">Link</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#">Link</a>
        </li>
      </ul>
    </div>
  </div>
)

export default Popupmenu



// WEBPACK FOOTER //
// ./src/components/Popupmenu/index.js